import { useContext } from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import type { RetryReason } from '@/types/dataCollection'

interface RetryNoticeProps {
  reason: RetryReason
}

/**
 * Banner shown above the first screen after the backend rewound the user to data collection
 * (e.g. open banking failed). Informational only: the actual choice (retry or documents) is made
 * on the evidence screen.
 */
export const RetryNotice = observer(({ reason }: RetryNoticeProps) => {
  const { dataCollectionPage: trans } = useContext(StoreContext).TranslationsState.translations
  const copy = trans?.retryNotice?.[reason]
  if (!copy) return null

  return (
    <div className="data-collection__notice" role="status" data-testid="data-collection-notice">
      <span className="data-collection__notice-icon">
        <Icon type="warning" size="20px" color="var(--data-collection-notice-icon, #072543)" />
      </span>
      <div className="data-collection__notice-body">
        <span className="data-collection__notice-title">{copy.title}</span>
        <span className="data-collection__notice-text">{copy.text}</span>
      </div>
    </div>
  )
})
